import React, { useContext, useEffect, useState } from "react";
import "../../../styles/Proof.css";
import SelectContext from "../../../utils/Context/SelectContext";
import { base_url } from "../../../utils/apiConfig";
import axios from "axios";
import { Outlet } from "react-router-dom";

const Proof = ({ storeData }) => {
  const queDataListId = storeData?.id;
  const { setSelectedOption } = useContext(SelectContext);
  const [adutiCycleTypesDataList, setAdutiCycleTypesDataList] = useState([]);
  const [selectedAuditId, setSelectedAuditId] = useState("");
  const [proofAuditList, setProofAuditList] = useState([]);
  const [postApiData, setPostApiData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const handleImageClick = (imageUrl) => setSelectedImage(imageUrl);
  const closeImage = () => setSelectedImage(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        const response = await axios.get(
          `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/store/${queDataListId}/proof_tag_list`,
          {
            headers: {
              Authorization: `token ${authToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        setAdutiCycleTypesDataList(response.data);
        if (response.data.length > 0) {
          const defaultId = response.data[0].id;
          setSelectedOption(response.data[0].proof_tag?.name || "Unnamed");
          fetchProofAuditData(defaultId);
        }
      } catch (error) {
        console.log("Something wrong", error);
      }
    };
    fetchData();
  }, [queDataListId, setSelectedOption]);

  const fetchProofAuditData = async (auditId) => {
    // setIsLoading(true);
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await axios.get(
        `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/store/${queDataListId}/questionnaire_types_list_for_comparison`,
        {
          headers: {
            Authorization: `token ${authToken}`,
            "Content-Type": "application/json",
          },
          params: {
            proof_tag_id: auditId,
          },
        },
      );
      setProofAuditList(response.data);
    } catch (error) {
      console.log("Something wrong fetching proof audit data", error);
    } finally {
      // setIsLoading(false);
    }
  };

  const auditQuestionnaireID = proofAuditList?.[0]?.id || null;

  const handleSelectChange = async (event) => {
    const newSelectedId = parseInt(event.target.value, 10);
    setSelectedAuditId(newSelectedId);
    const selectedName = event.target.options[event.target.selectedIndex].text;
    setSelectedOption(selectedName);
    fetchProofAuditData(newSelectedId);

    try {
      const authToken = localStorage.getItem("authToken");
      const payload = {
        proof_tag_id: newSelectedId.toString(),
        questionnaireTypeId: auditQuestionnaireID.toString(),
      };

      const response = await axios.post(
        `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/store/${queDataListId}/get_proofs_by_tag`,
        payload,
        {
          headers: {
            Authorization: `token ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      setPostApiData(response.data);
    } catch (error) {
      console.log("Something went wrong please wait");
    }
  };

  return (
    <div className="my-4">
      <p className="proof-head text-center">
        Please select tag for Type of Audit Wise Comparison
      </p>
      <div className="main">
        <div className="proof-select my-2 gap-3 d-flex">
          <p className="my-2 Questype">Proof Type:</p>
          <select
            value={selectedAuditId === "" ? "" : selectedAuditId}
            onChange={handleSelectChange}
            style={{ cursor: "pointer", color: "#000" }}
          >
            <option value="" disabled hidden>
              Select Proof Type
            </option>
            {adutiCycleTypesDataList.map((audit) => (
              <option
                key={audit.id}
                value={audit.id}
                style={{ cursor: "pointer" }}
              >
                {audit.proof_tag?.name || "Unnamed"}
              </option>
            ))}
          </select>
        </div>
        <div className="proof-lower my-3 shadow row">
          {postApiData.length > 0 ? (
            postApiData.map((proof, index) => (
              <div className="col-md-4 my-3" key={proof.id || index}>
                <div className="text-center">
                  <p className="text-center m-2">{proof.name}</p>
                </div>
                <div className="d-flex flex-wrap justify-content-center gap-3">
                  {proof.attachments?.length > 0 ? (
                    proof.attachments.map((attachment) =>
                      attachment.proof_type === "PHOTO" ? (
                        <div className="divImg">
                          <img
                            key={attachment.id}
                            src={
                              attachment.extra?.thumbnail_url ||
                              attachment.direct_url
                            }
                            alt={attachment.file_name || "Photo Attachment"}
                            className="mainImg"
                            onClick={() =>
                              handleImageClick(
                                attachment.extra?.preview_url ||
                                  attachment.direct_url,
                              )
                            }
                            onError={(e) =>
                              (e.target.src = "fallback-image-url.jpg")
                            }
                          />
                          <i
                            className="bi bi-eye iconImg"
                            onClick={() =>
                              handleImageClick(
                                attachment.extra?.preview_url ||
                                  attachment.direct_url,
                              )
                            }
                          />
                          <span
                            className="hoverText"
                            onClick={() =>
                              handleImageClick(
                                attachment.extra?.preview_url ||
                                  attachment.direct_url,
                              )
                            }
                          >
                            Click to View
                          </span>
                        </div>
                      ) : attachment.proof_type === "VIDEO" ? (
                        <video
                          key={attachment.id}
                          controls
                          style={{
                            width: "200px",
                            height: "150px",
                            borderRadius: "8px",
                          }}
                        >
                          <source
                            src={attachment.direct_url}
                            type={attachment.mime_type}
                          />
                          Your browser does not support the video tag.
                        </video>
                      ) : attachment.proof_type === "AUDIO" ? (
                        <audio key={attachment.id} controls>
                          <source
                            src={attachment.direct_url}
                            type={attachment.mime_type}
                          />
                          Your browser does not support the audio tag.
                        </audio>
                      ) : (
                        <p key={attachment.id}>Unsupported attachment type</p>
                      ),
                    )
                  ) : (
                    <p style={{ fontSize: "16px", color: "#007dc1" }}>
                      No attachments available
                    </p>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p className="text-center m-4">Please select a proof type</p>
          )}
        </div>
      </div>
      {selectedImage && (
        <div
          className="floating-image-container"
          onClick={closeImage}
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "9999",
          }}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90vw",
              maxHeight: "90vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage}
              alt="Selected View"
              style={{
                width: "auto",
                height: "auto",
                objectFit: "contain",
                borderRadius: "8px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
              }}
            />
          </div>
        </div>
      )}
      <Outlet />
    </div>
  );
};

export default Proof;
